// extracted by mini-css-extract-plugin
export default {"tabPanel":"src-TabPanel-module__tabPanel--gZ9QI","focus-visible":"src-TabPanel-module__focus-visible--t5WNw"};